import { useEffect, useState } from "react";
import {
  BUILTIN_BUNDLE,
  loadBundle,
  type Content,
  type LoadOptions,
} from "../lib/content.js";

/**
 * Startet mit der eingebackenen Fassung und ersetzt sie, wenn eine Klassenfassung
 * geladen wurde. Kein Ladebildschirm: im Gastmodus gibt es nichts zu laden, und
 * im Klassenbetrieb soll das Kind sofort etwas sehen.
 */
export function useBundle(optionen: LoadOptions = {}): Content {
  const [content, setContent] = useState<Content>({
    bundle: BUILTIN_BUNDLE,
    herkunft: { kind: "builtin" },
  });
  const version = optionen.version;

  useEffect(() => {
    if (!version) return;
    const abbruch = new AbortController();
    void loadBundle({ ...optionen, version, signal: abbruch.signal }).then((neu) => {
      if (!abbruch.signal.aborted) setContent(neu);
    });
    return () => abbruch.abort();
    // Nur die Fassung ist der Auslöser; die übrigen Optionen sind Konfiguration.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version?.slug, version?.version]);

  return content;
}
